export default "__VITE_ASSET__CPwLvXwH__"